export const formatAmount = (units: number | bigint, decimals = 1, fixed = 8) => {
  const value = typeof units === 'bigint' ? Number(units) : units;
  const divider = 10 ** decimals;
  const raw = value / divider;
  const formatted = raw.toFixed(fixed).replace(/\.?0+$/, '');
  return { raw, formatted };
};
